




import Vue from 'vue';
import BulkAddUsersUpload from '@/components/bulk-add-users/bulk-add-users-upload.component.vue';
export default Vue.extend({
  components: {
    'bulk-add-users-upload': BulkAddUsersUpload
  }
});
